import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogBackdrop, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { FieldLabel } from '@systemeio/ui';
import { NotificationMenuMobile } from 'modules/notifications/components/notifications-menu-mobile';
import { useRouter } from 'next/router';
import React, { Fragment, useEffect } from 'react';
import SideMenuItem from 'shared/components/header/components/side-menu/components/side-menu-item';
import WorkspaceSelector from 'shared/components/header/components/workspace-selector';
import { useMenuItems } from 'shared/components/header/hooks/use-menu-items';
import { MobileLanguageSwitcher } from 'shared/components/language-switcher/mobile-language-switcher';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { ScreenHeightDiv } from 'shared/components/screen-height-div';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { SubAccountSelector } from '../sub-account-selector';
import { ArrowLeftIcon, BurgerIcon, LogoutIcon, OpenInNewIcon } from '@systemeio/ui/icons';
import { hasSubAccounts } from 'shared/hooks/use-user/utils/has-subaccounts';
import { twJoin } from 'tailwind-merge';
interface SideMenuProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const SideMenu = t0 => {
  const $ = _c(78);
  const {
    isOpen,
    setIsOpen
  } = t0;
  const {
    isWorkspaceOwner,
    user,
    isLoading,
    isDisabled,
    isSupportImpersonation,
    shouldShowSubAccountPage,
    avatarUrl
  } = useUser();
  const {
    menuItems,
    isReady
  } = useMenuItems();
  const {
    t
  } = useLocoTranslation();
  const {
    pathname
  } = useRouter();
  const isSettingsPage = pathname.includes("/profile");
  const isSubaccountPage = pathname.includes("/subaccounts");
  const hasWorkspaces = user?.workspaceMemberships && Array.isArray(user.workspaceMemberships) && user.workspaceMemberships.length > 0;
  let t1;
  if ($[0] !== setIsOpen) {
    t1 = () => {
      setIsOpen(false);
    };
    $[0] = setIsOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== pathname || $[3] !== setIsOpen) {
    t2 = [pathname, setIsOpen];
    $[2] = pathname;
    $[3] = setIsOpen;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  const t3 = `${(isLoading || !isReady) && "animate-pulse"} flex w-full items-center justify-end gap-5`;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <NotificationMenuMobile />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = isLoading || !isReady;
  let t6;
  if ($[6] !== setIsOpen) {
    t6 = () => setIsOpen(true);
    $[6] = setIsOpen;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <BurgerIcon className="h-8 w-8" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t6) {
    t8 = <button disabled={t5} aria-label="Open Menu" onClick={t6}>{t7}</button>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const T0 = Transition;
  const t9 = Fragment;
  const T1 = Dialog;
  const t10 = "fixed inset-0 z-10";
  let t11;
  if ($[12] !== setIsOpen) {
    t11 = () => setIsOpen(false);
    $[12] = setIsOpen;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <TransitionChild as={Fragment} enter="ease duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"><DialogBackdrop className="fixed inset-0 bg-black/50" /></TransitionChild>;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const T2 = TransitionChild;
  const t13 = Fragment;
  const t14 = "ease-out duration-300";
  const t15 = "opacity-0 translate-x-full";
  const t16 = "opacity-100 translate-x-0";
  const t17 = "ease-in duration-200";
  const t18 = "opacity-100 translate-x-0";
  const t19 = "opacity-0 translate-x-full";
  const T3 = DialogPanel;
  const T4 = ScreenHeightDiv;
  const t20 = "bg-background-secondary text-text-primary fixed right-0 top-0 z-10 flex min-w-[17rem] max-w-[350px]  flex-col overflow-auto px-4 py-5";
  let t21;
  if ($[15] !== setIsOpen) {
    t21 = () => setIsOpen(false);
    $[15] = setIsOpen;
    $[16] = t21;
  } else {
    t21 = $[16];
  }
  let t22;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <ArrowLeftIcon className="stroke-text-primary" />;
    $[17] = t22;
  } else {
    t22 = $[17];
  }
  let t23;
  if ($[18] !== t) {
    t23 = t("global.back_to_page");
    $[18] = t;
    $[19] = t23;
  } else {
    t23 = $[19];
  }
  let t24;
  if ($[20] !== t23) {
    t24 = <span>{t23}</span>;
    $[20] = t23;
    $[21] = t24;
  } else {
    t24 = $[21];
  }
  let t25;
  if ($[22] !== t21 || $[23] !== t24) {
    t25 = <div onClick={t21} className="flex w-fit cursor-pointer items-center gap-2">{t22}{t24}</div>;
    $[22] = t21;
    $[23] = t24;
    $[24] = t25;
  } else {
    t25 = $[24];
  }
  const t26 = !isDisabled && user && <div className="flex flex-col gap-3.5 py-6"><div className="flex justify-between gap-3.5">{isWorkspaceOwner ? <div className="flex items-center gap-3.5"><img className="h-10 w-10 overflow-hidden rounded-full object-cover" src={avatarUrl} alt={`${user.firstName} ${user.lastName}`} /><div className="flex flex-col"><span className="text-base font-semibold">{user.firstName} {user.lastName}</span><LinkWithoutPrefetch href="/profile/user-settings" className={twJoin(isSettingsPage && "text-brand-primary")}>{t("global.settings")}</LinkWithoutPrefetch>{!hasSubAccounts(user) && shouldShowSubAccountPage && <LinkWithoutPrefetch className={twJoin(isSubaccountPage && "text-brand-primary")} href="/subaccounts">{t("header.user.profile.menu.sub_accounts")}</LinkWithoutPrefetch>}</div></div> : <div className="flex items-center gap-3.5"><img className="h-10 w-10 overflow-hidden rounded-full object-cover" src={avatarUrl} alt={`${user.firstName} ${user.lastName}`} /><div className="flex flex-col"><span className="text-base font-semibold">{user.firstName} {user.lastName}</span><LinkWithoutPrefetch href="/profile/account-settings" className={isSettingsPage ? "text-brand-primary" : ""}>{t("global.settings")}</LinkWithoutPrefetch>{!hasSubAccounts(user) && shouldShowSubAccountPage && <LinkWithoutPrefetch className={isSubaccountPage ? "text-brand-primary" : ""} href="/subaccounts">{t("header.user.profile.menu.sub_accounts")}</LinkWithoutPrefetch>}</div></div>}<MobileLanguageSwitcher /></div>{hasSubAccounts(user) && isWorkspaceOwner && <div className="flex flex-col"><FieldLabel labelClassName="mb-1" label={<div className="flex gap-1.5">{t("header.user.profile.menu.sub_accounts")}{shouldShowSubAccountPage && <LinkWithoutPrefetch href="/subaccounts" className="group self-center outline-hidden"><OpenInNewIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary" /></LinkWithoutPrefetch>}</div>} /><SubAccountSelector /></div>}</div>;
  let t27;
  if ($[25] !== isDisabled || $[26] !== menuItems || $[27] !== user) {
    t27 = user && !isDisabled && menuItems.map(_temp);
    $[25] = isDisabled;
    $[26] = menuItems;
    $[27] = user;
    $[28] = t27;
  } else {
    t27 = $[28];
  }
  let t28;
  if ($[29] !== t27) {
    t28 = <div className="flex flex-col gap-8 py-4">{t27}</div>;
    $[29] = t27;
    $[30] = t28;
  } else {
    t28 = $[30];
  }
  let t29;
  if ($[31] !== hasWorkspaces || $[32] !== t) {
    t29 = hasWorkspaces && <FieldLabel labelClassName="mb-1" label={t("header.user.profile.menu.workspace")} />;
    $[31] = hasWorkspaces;
    $[32] = t;
    $[33] = t29;
  } else {
    t29 = $[33];
  }
  let t30;
  if ($[34] !== setIsOpen) {
    t30 = <WorkspaceSelector afterChange={() => setIsOpen(false)} className="text-text-primary" />;
    $[34] = setIsOpen;
    $[35] = t30;
  } else {
    t30 = $[35];
  }
  let t31;
  if ($[36] !== t29 || $[37] !== t30) {
    t31 = <div>{t29}{t30}</div>;
    $[36] = t29;
    $[37] = t30;
    $[38] = t31;
  } else {
    t31 = $[38];
  }
  let t32;
  if ($[39] !== isSupportImpersonation || $[40] !== t) {
    t32 = isSupportImpersonation && <a href="/dashboard/back/entry?pretend_this_user=_exit"><p className="cursor-pointer px-2">{t("header.exit_impersonation")}</p></a>;
    $[39] = isSupportImpersonation;
    $[40] = t;
    $[41] = t32;
  } else {
    t32 = $[41];
  }
  let t33;
  if ($[42] !== t) {
    t33 = t("header.user.profile.menu.logout");
    $[42] = t;
    $[43] = t33;
  } else {
    t33 = $[43];
  }
  let t34;
  if ($[44] !== t33) {
    t34 = <div className="flex items-center"><SideMenuItem item={{
        mobileIconRenderer: _temp2,
        href: "/logout",
        name: t33,
        isActive: _temp3,
        shouldRender: true
      }} /></div>;
    $[44] = t33;
    $[45] = t34;
  } else {
    t34 = $[45];
  }
  let t35;
  if ($[46] !== t31 || $[47] !== t32 || $[48] !== t34) {
    t35 = <div className="mt-auto flex flex-col gap-3">{t31}{t32}{t34}</div>;
    $[46] = t31;
    $[47] = t32;
    $[48] = t34;
    $[49] = t35;
  } else {
    t35 = $[49];
  }
  let t36;
  if ($[50] !== T4 || $[51] !== t25 || $[52] !== t26 || $[53] !== t28 || $[54] !== t35) {
    t36 = <T4 className={t20}>{t25}{t26}{t28}{t35}</T4>;
    $[50] = T4;
    $[51] = t25;
    $[52] = t26;
    $[53] = t28;
    $[54] = t35;
    $[55] = t36;
  } else {
    t36 = $[55];
  }
  let t37;
  if ($[56] !== T3 || $[57] !== t36) {
    t37 = <T3>{t36}</T3>;
    $[56] = T3;
    $[57] = t36;
    $[58] = t37;
  } else {
    t37 = $[58];
  }
  let t38;
  if ($[59] !== T2 || $[60] !== t13 || $[61] !== t37) {
    t38 = <T2 as={t13} enter={t14} enterFrom={t15} enterTo={t16} leave={t17} leaveFrom={t18} leaveTo={t19}>{t37}</T2>;
    $[59] = T2;
    $[60] = t13;
    $[61] = t37;
    $[62] = t38;
  } else {
    t38 = $[62];
  }
  let t39;
  if ($[63] !== T1 || $[64] !== t11 || $[65] !== t12 || $[66] !== t38) {
    t39 = <T1 className={t10} onClose={t11}>{t12}{t38}</T1>;
    $[63] = T1;
    $[64] = t11;
    $[65] = t12;
    $[66] = t38;
    $[67] = t39;
  } else {
    t39 = $[67];
  }
  let t40;
  if ($[68] !== T0 || $[69] !== isOpen || $[70] !== t39 || $[71] !== t9) {
    t40 = <T0 show={isOpen} as={t9}>{t39}</T0>;
    $[68] = T0;
    $[69] = isOpen;
    $[70] = t39;
    $[71] = t9;
    $[72] = t40;
  } else {
    t40 = $[72];
  }
  let t41;
  if ($[73] !== t3 || $[74] !== t4 || $[75] !== t40 || $[76] !== t8) {
    t41 = <div className={t3}>{t4}{t8}{t40}</div>;
    $[73] = t3;
    $[74] = t4;
    $[75] = t40;
    $[76] = t8;
    $[77] = t41;
  } else {
    t41 = $[77];
  }
  return t41;
};
export default SideMenu;
function _temp(item, idx) {
  return <SideMenuItem key={idx} item={item} />;
}
function _temp2() {
  return <LogoutIcon />;
}
function _temp3() {
  return false;
}